import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '../httpClient/http-client.service';

export interface TimezoneInfo {
  abbr: string;
  label?: string;
  offset: string;
  iana?: string;
}

export interface CalendarInvitePayload {
  name: string;
  from: string;
  to: string;
  cc?: string;
  subject: string;
  startTime: string;
  endTime: string;
  calenderName: string;
  description: string;
  organizer: string;
  attendees: string;
  url?: string;
  location?: string;
  platform: string;
  recurrence?: string;
  timezone?: TimezoneInfo;
  attachments?: File[];
}

@Injectable({
  providedIn: 'root'
})
export class MeetingEventService {
  private readonly httpClientService = inject(HttpClientService);

  constructor() {}

  sendCalendarInvite(payload: CalendarInvitePayload): Observable<any> {
    const url = `v1/api/userMailMaster/incoming-email/sendMailCalenderInvite?name=${encodeURIComponent(
      payload.name
    )}&from=${encodeURIComponent(payload.from)}`;

    const formData = new FormData();

    // Append form fields
    formData.append('to', payload.to);
    if (payload.cc) formData.append('cc', payload.cc);
    formData.append('subject', payload.subject);
    formData.append('startTime', payload.startTime);
    formData.append('endTime', payload.endTime);
    formData.append('calenderName', payload.calenderName);
    formData.append('description', payload.description);
    formData.append('organizer', payload.organizer);
    formData.append('attendees', payload.attendees);
    if (payload.url) formData.append('url', payload.url);
    if (payload.location) formData.append('location', payload.location);
    formData.append('platform', payload.platform);
    if (payload.recurrence) formData.append('recurrence', payload.recurrence);
    if (payload.timezone) formData.append('timezone', JSON.stringify(payload.timezone));

    // Append file attachments
    if (payload.attachments && payload.attachments.length > 0) {
      payload.attachments.forEach((file, index) => {
        formData.append(`attachments`, file, file.name);
      });
    }

    return this.httpClientService.post(url, formData, false, false, true);
  }
}